import { RateSet, Rates } from '../hooks/useRates';

const pad = (n: number) => String(n).padStart(2, '0');

export const todayString = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// Pure date-string arithmetic in UTC so time zones/DST never shift a night.
export const addDays = (date: string, days: number) => {
  const d = new Date(`${date}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
};

// The rates that apply to the night of `date`: a matching special-pricing
// range if there is one, otherwise the regular rates.
export const rateSetForDate = (rates: Rates, date: string): RateSet => {
  const o = rates.overrides.find((x) => date >= x.startDate && date <= x.endDate);
  return o ?? rates;
};
